export default "/_next/static/images/28c8e0b6064a50358472f92a552ee8ab.jpg";